import { escapeHtml as esc } from './escapeHtml'

function stagePreviewRows (stage) {
  const rows = []
  rows.push(['Type', stage.stageType || 'traditional'])
  if (stage.mediaType) rows.push(['Media', stage.mediaType])
  if (stage.input) rows.push(['Input', stage.validations ? stage.validations.type : 'Yes'])
  if (stage.joRDelayConfig && stage.joRDelayConfig.delay) {
    const d = stage.joRDelayConfig.delay
    rows.push(['Delay', `${d.quantity} ${d.units}`])
  }
  if (stage.processingFunctionConfig) rows.push(['Function', stage.processingFunctionConfig.functionName])
  if (stage.conversation) rows.push(['Conversation', stage.conversation])
  if (stage.media) rows.push(['Asset', stage.media])
  if (Array.isArray(stage.tags) && stage.tags.length) rows.push(['Tags', stage.tags.join(', ')])
  if (stage.nextApp) rows.push(['Ends chat', 'Yes'])
  return rows
}

export function renderStagePreview (stage) {
  const rows = stagePreviewRows(stage)
  if (!rows.length) return ''
  return '<div class="stage-kv">' + rows.map(([k, v]) => `<div class="stage-kv-row"><span class="k">${esc(k)}</span><span class="v">${esc(v)}</span></div>`).join('') + '</div>'
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/stageCardPreview.js